import { CalendarEvent } from '../../views/Bookings/types';
import { BranchAppointmentTag } from '../../views/Store/BranchTags/types';
import { startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from 'date-fns';

export const getMultiDayBookingsForDay = ({ multiDayBookings, weekDay, firstDayOfView }: { multiDayBookings: CalendarEvent[]; weekDay: Date; firstDayOfView: Date }) => {
  return multiDayBookings.filter(booking => {
    const timestamp = new Date(booking.timestamp);
    timestamp.setHours(weekDay.getHours());
    timestamp.setMinutes(weekDay.getMinutes());
    return timestamp.getTime() === weekDay.getTime() || (timestamp.getTime() < firstDayOfView.getTime() && weekDay.getDate() === firstDayOfView.getDate());
  });
};

export const groupMultiDayBookingsByTags = ({ filterByTagsIds, multiDayBookings }: { multiDayBookings: CalendarEvent[]; filterByTagsIds: string[] }) => {
  const multiDayAppointmentsForTagsToRender = filterByTagsIds?.reduce<{ [key: string]: string[] }>((acc, tagId) => {
    const appointmentsThatHaveTag = multiDayBookings.filter(booking => {
      const bookingTags = booking.branchAppointmentTagsCount?.map(tagCount => tagCount.BranchAppointmentTag?.id);
      return bookingTags?.includes(tagId);
    });
    return { ...acc, [tagId]: appointmentsThatHaveTag.map(booking => booking.appointmentsIds[0]) };
  }, {});

  return multiDayAppointmentsForTagsToRender;
};

export const getNumberOfRowsForTags = ({
  multiDayAppointmentsForTagsToRender,
  filterByTags
}: {
  multiDayAppointmentsForTagsToRender: { [key: string]: string[] };
  filterByTags?: BranchAppointmentTag[];
}) => {
  const filterByTagsIds = (filterByTags || [])?.map(tag => tag.id);
  const rows = filterByTagsIds.map(tagId => {
    const bookingsIds = multiDayAppointmentsForTagsToRender?.[tagId];

    const currentTagCapacity = filterByTags?.find(tag => tag.id === tagId)?.capacity;
    const maxTagRows = Math.max(currentTagCapacity || 0, bookingsIds?.length || 0);
    const currentTagRows = maxTagRows === 0 ? 1 : maxTagRows;
    const numberOfAppointmentsWithinTimePeriod = bookingsIds?.length || 0;
    return { tagId, currentTagRows: currentTagRows, numberOfAppointmentsWithinTimePeriod };
  });
  return rows;
};

export function calcRange(view: string, date: Date) {
  let range = { from: date, to: date };
  if (view === 'day') {
    range = { from: startOfDay(date), to: endOfDay(date) };
  } else if (view === 'week') {
    range = { from: startOfWeek(date, { weekStartsOn: 1 }), to: endOfDay(endOfWeek(date, { weekStartsOn: 1 })) };
  } else if (view === 'month') {
    range = { from: startOfMonth(date), to: endOfDay(endOfMonth(date)) };
  }
  return range;
}

export function extractRange(range: Date[] | { start: Date; end: Date }) {
  let start = range.start;
  let end = range.end;

  if (range.length === 1) {
    // day
    start = range[0];
    end = endOfDay(range[0]);
  } else if (range.length > 1) {
    // week

    start = range[0];
    end = range.slice(-1)[0];
  }

  return { start, end };
}

export const adjustCalendarDomView = () => {
  setTimeout(() => {
    const allDayHeaders = document.querySelectorAll('.rbc-allday-cell');

    if (allDayHeaders) {
      allDayHeaders.forEach(h => (h.style.display = 'none'));
    }
  }, 100);
};
